<ion-card *ngIf="storeInfo && groupApp && !groupApp.active_reservation_app">
  <ion-item-divider mode="ios">
    <ion-label>
      {{
        storeInfo && storeInfo.hidePaymentGateways
          ? ("cart.cart-components.payment-methods.invoice-info" | translate)
          : ("cart.cart-components.payment-methods.payment-methods" | translate)
      }}
    </ion-label>
  </ion-item-divider>

  <app-checkbox-promotions-online-payment
    *ngIf="storeInfo && !storeInfo.hidePaymentGateways"
  ></app-checkbox-promotions-online-payment>

  <span
    *ngIf="
      ((paymentGateways && paymentGateways.length >= 0) ||
        (filteredCartPaymentGateWays &&
          filteredCartPaymentGateWays['mobilePOS'] &&
          filteredCartPaymentGateWays['mobilePOS'].active)) &&
      storeInfo &&
      !storeInfo.hidePaymentGateways
    "
  >
    <ion-radio-group
      [(ngModel)]="displaySelectedPaymentMethodID"
      (ionChange)="selectPaymentMethodRadio($event)"
    >
      <ion-list class="ion-no-padding">
        <span
          #span
          *ngFor="
            let paymentMethod of filteredCartPaymentGateWays
              | orderPaymentMethods : resolvedPaymentMethodOrder
          "
        >
          <ion-item
            [disabled]="
              finalPriceLoading ||
              checkForDisablingSomeMethods(
                paymentMethod.key,
                paymentMethod.value,
                null
              ) ||
              paymentMethod.value.deliveryMethodErrMsg ||
              paymentMethod.value.networkErrMessage ||
              paymentMethod.value.newCustomerCashErrMsg
            "
            lines="full"
            *ngIf="
              paymentMethod &&
              paymentMethod.value &&
              paymentMethod.value.active &&
              !paymentMethod.value.hideForDeliveryMethod &&
              (!paymentMethod.value.adminOnly ||
                (currentUser && currentUser.admin)) &&
              (!paymentMethod.value.customerOnly ||
                (currentUser &&
                  ((currentUser.admin && paymentMethod.value.adminOnly) ||
                    (currentUser.customerPaymentMethods &&
                      currentUser.customerPaymentMethods[
                        paymentMethod.value.sourcePaymentMethodKey ||
                          paymentMethod.key
                      ])))) &&
              !(
                currentUser &&
                currentUser.disabledPaymentMethods &&
                currentUser.disabledPaymentMethods[
                  paymentMethod.value.sourcePaymentMethodKey ||
                    paymentMethod.key
                ]
              )
            "
          >
            <ion-label
              class="ion-text-wrap"
              *ngIf="
                paymentMethod.key === 'cash' ||
                paymentMethod.key === 'pre_cash' ||
                paymentMethod.value.renderLikeCash
              "
              ><span
                *ngIf="
                  paymentMethod.value.labelTranslationKey;
                  else defaultCashPaymentMethodLabel
                "
                >{{ paymentMethod.value.labelTranslationKey | translate }}</span
              >
              <ng-template #defaultCashPaymentMethodLabel>
                <span
                  *ngIf="
                    paymentMethod.value.mobileorderDisplayLabel;
                    else translatedCashPaymentMethodLabel
                  "
                  >{{ paymentMethod.value.mobileorderDisplayLabel }}</span
                >
                <ng-template #translatedCashPaymentMethodLabel>
                  {{
                    "cart.cart-components.payment-methods." + paymentMethod.key
                      | translate
                  }}
                </ng-template>
              </ng-template>
              <div
                *ngIf="
                  checkForDisablingSomeMethods(
                    paymentMethod.key,
                    paymentMethod.value,
                    null
                  )
                "
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    "cart.cart-components.payment-methods.temporary-disabled"
                      | translate
                  }}</ion-text
                >
              </div>

              <div
                style="line-height: 1"
                *ngIf="
                  paymentMethod.value.deliveryMethodErrMsg ||
                  paymentMethod.value.networkErrMessage
                "
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.deliveryMethodErrMsg ||
                      paymentMethod.value.networkErrMessage
                      | dineinTableLabel: dineinTableContext
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="paymentMethod.value.maxAmountErrMsg"
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.maxAmountErrMsg
                      | translate
                        : {
                            amount:
                              (paymentMethod.value.mo_max_amount
                              | priceWithComma
                                : storeInfo && storeInfo.showPricesWithComma),
                            currencySymbol:
                              storeInfo && storeInfo.currencySymbol
                                ? storeInfo.currencySymbol
                                : "€"
                          }
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="paymentMethod.value.minAmountErrMsg"
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.minAmountErrMsg
                      | translate
                        : {
                            amount:
                              (paymentMethod.value.mo_min_amount
                              | priceWithComma
                                : storeInfo && storeInfo.showPricesWithComma),
                            currencySymbol:
                              storeInfo && storeInfo.currencySymbol
                                ? storeInfo.currencySymbol
                                : "€"
                          }
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="paymentMethod.value.newCustomerCashErrMsg"
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.newCustomerCashErrMsg
                      | translate
                        : {
                            amount:
                              (paymentMethod.value.newCustomerCashCapAmount
                              | priceWithComma
                                : storeInfo && storeInfo.showPricesWithComma),
                            currencySymbol:
                              storeInfo && storeInfo.currencySymbol
                                ? storeInfo.currencySymbol
                                : "€"
                          }
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="
                  currentUser &&
                  ((paymentMethod.value?.dinein_visitors
                    ?.only_network_visitors &&
                    currentUser.only_dinein) ||
                    paymentMethod.value?.dinein_users?.only_network_users) &&
                  !paymentMethod.value.deliveryMethodErrMsg &&
                  !paymentMethod.value.networkErrMessage &&
                  storeNetworkConnected
                "
              >
                <ion-text color="complete" style="font-size: small">
                  {{
                    "cart.cart-components.payment-methods.you-are-connected-to-stores-network"
                      | translate
                  }}</ion-text
                >
              </div>
            </ion-label>

            <ion-label
              class="ion-text-wrap"
              *ngIf="
                paymentMethod.key === 'mobilePOS' ||
                paymentMethod.key === 'pre_mobilePOS'
              "
            >
              <span
                *ngIf="
                  paymentMethod.value.mobileorderDisplayLabel;
                  else translatedMobilePosPaymentMethodLabel
                "
                >{{ paymentMethod.value.mobileorderDisplayLabel }}</span
              >
              <ng-template #translatedMobilePosPaymentMethodLabel>
                <ion-text *ngIf="paymentMethod.key === 'pre_mobilePOS'">
                  {{
                    "cart.cart-components.payment-methods.pre_mobilePOS"
                      | translate
                  }}
                </ion-text>
                <ion-text
                  *ngIf="
                    paymentMethod.key === 'mobilePOS' &&
                    orderPickup == null &&
                    dineIn == null
                  "
                >
                  {{
                    "cart.cart-components.payment-methods.mobilePOS" | translate
                  }}
                </ion-text>
                <ion-text
                  *ngIf="
                    paymentMethod.key === 'mobilePOS' &&
                    orderPickup == true &&
                    dineIn == false
                  "
                >
                  {{
                    "cart.cart-components.payment-methods.mobilePOS-takeaway"
                      | translate
                  }}
                </ion-text>
                <ion-text
                  *ngIf="
                    paymentMethod.key === 'mobilePOS' &&
                    orderPickup == false &&
                    dineIn == false
                  "
                >
                  {{
                    "cart.cart-components.payment-methods.mobilePOS-delivery"
                      | translate
                  }}
                </ion-text>
                <ion-text
                  *ngIf="
                    paymentMethod.key === 'mobilePOS' &&
                    orderPickup == false &&
                    dineIn == true
                  "
                >
                  {{
                    currentUser && currentUser.uposMoUser
                      ? ("cart.cart-components.payment-methods.mobilePOS-takeaway"
                        | translate)
                      : ("cart.cart-components.payment-methods.mobilePOS-dinein"
                        | translate)
                  }}
                </ion-text>
              </ng-template>
              <div
                *ngIf="
                  checkForDisablingSomeMethods(
                    paymentMethod.key,
                    paymentMethod.value,
                    null
                  )
                "
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    "cart.cart-components.payment-methods.temporary-disabled"
                      | translate
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="
                  paymentMethod.value.deliveryMethodErrMsg ||
                  paymentMethod.value.networkErrMessage
                "
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.deliveryMethodErrMsg ||
                      paymentMethod.value.networkErrMessage
                      | dineinTableLabel: dineinTableContext
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="paymentMethod.value.maxAmountErrMsg"
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.maxAmountErrMsg
                      | translate
                        : {
                            amount:
                              (paymentMethod.value.mo_max_amount
                              | priceWithComma
                                : storeInfo && storeInfo.showPricesWithComma),
                            currencySymbol:
                              storeInfo && storeInfo.currencySymbol
                                ? storeInfo.currencySymbol
                                : "€"
                          }
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="paymentMethod.value.minAmountErrMsg"
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.minAmountErrMsg
                      | translate
                        : {
                            amount:
                              (paymentMethod.value.mo_min_amount
                              | priceWithComma
                                : storeInfo && storeInfo.showPricesWithComma),
                            currencySymbol:
                              storeInfo && storeInfo.currencySymbol
                                ? storeInfo.currencySymbol
                                : "€"
                          }
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="paymentMethod.value.newCustomerCashErrMsg"
              >
                <ion-text color="danger" style="font-size: small">
                  {{
                    paymentMethod.value.newCustomerCashErrMsg
                      | translate
                        : {
                            amount:
                              (paymentMethod.value.newCustomerCashCapAmount
                              | priceWithComma
                                : storeInfo && storeInfo.showPricesWithComma),
                            currencySymbol:
                              storeInfo && storeInfo.currencySymbol
                                ? storeInfo.currencySymbol
                                : "€"
                          }
                  }}</ion-text
                >
              </div>
              <div
                style="line-height: 1"
                *ngIf="
                  currentUser &&
                  ((paymentMethod.value?.dinein_visitors
                    ?.only_network_visitors &&
                    currentUser.only_dinein) ||
                    paymentMethod.value?.dinein_users?.only_network_users) &&
                  !paymentMethod.value.deliveryMethodErrMsg &&
                  !paymentMethod.value.networkErrMessage &&
                  storeNetworkConnected
                "
              >
                <ion-text color="complete" style="font-size: small">
                  {{
                    "cart.cart-components.payment-methods.you-are-connected-to-stores-network"
                      | translate
                  }}</ion-text
                >
              </div>
            </ion-label>
            <ion-radio
              style="margin-right: 13px"
              [value]="paymentMethod.key"
              slot="start"
            ></ion-radio>

            <ion-row
              class="ion-justify-content-center ion-align-items-center"
              style="width: 100%; margin-top: 5px; margin-bottom: 5px"
              *ngIf="
                paymentMethod.key !== 'cash' &&
                !paymentMethod.value.renderLikeCash &&
                paymentMethod.key !== 'mobilePOS' &&
                paymentMethod.key !== 'pre_cash' &&
                paymentMethod.key !== 'pre_mobilePOS'
              "
            >
              <ion-col
                class="ion-no-padding ion-no-margin ion-text-left"
                [size]="5.5"
              >
                <ion-label class="ion-text-wrap">
                  <span
                    *ngIf="
                      paymentMethod.value.mobileorderDisplayLabel;
                      else translatedOnlinePaymentMethodLabel
                    "
                    >{{ paymentMethod.value.mobileorderDisplayLabel }}</span
                  >
                  <ng-template #translatedOnlinePaymentMethodLabel>
                    {{
                      "cart.cart-components.payment-methods." +
                        paymentMethod.key | translate
                    }}
                  </ng-template>
                  <div
                    *ngIf="
                      checkForDisablingSomeMethods(
                        paymentMethod.key,
                        paymentMethod.value,
                        null
                      )
                    "
                  >
                    <ion-text color="danger" style="font-size: small">
                      {{
                        "cart.cart-components.payment-methods.temporary-disabled"
                          | translate
                      }}</ion-text
                    >
                  </div>

                  <div
                    style="line-height: 1"
                    *ngIf="
                      paymentMethod.value.deliveryMethodErrMsg ||
                      paymentMethod.value.networkErrMessage
                    "
                  >
                    <ion-text color="danger" style="font-size: small">
                      {{
                        paymentMethod.value.deliveryMethodErrMsg ||
                          paymentMethod.value.networkErrMessage
                          | dineinTableLabel: dineinTableContext
                      }}</ion-text
                    >
                  </div>
                  <div
                    style="line-height: 1"
                    *ngIf="paymentMethod.value.maxAmountErrMsg"
                  >
                    <ion-text color="danger" style="font-size: small">
                      {{
                        paymentMethod.value.maxAmountErrMsg
                          | translate
                            : {
                                amount:
                                  (paymentMethod.value.mo_max_amount
                                  | priceWithComma
                                    : storeInfo &&
                                        storeInfo.showPricesWithComma),
                                currencySymbol:
                                  storeInfo && storeInfo.currencySymbol
                                    ? storeInfo.currencySymbol
                                    : "€"
                              }
                      }}</ion-text
                    >
                  </div>
                  <div
                    style="line-height: 1"
                    *ngIf="paymentMethod.value.minAmountErrMsg"
                  >
                    <ion-text color="danger" style="font-size: small">
                      {{
                        paymentMethod.value.minAmountErrMsg
                          | translate
                            : {
                                amount:
                                  (paymentMethod.value.mo_min_amount
                                  | priceWithComma
                                    : storeInfo &&
                                        storeInfo.showPricesWithComma),
                                currencySymbol:
                                  storeInfo && storeInfo.currencySymbol
                                    ? storeInfo.currencySymbol
                                    : "€"
                              }
                      }}</ion-text
                    >
                  </div>
                  <div
                    style="line-height: 1"
                    *ngIf="
                      currentUser &&
                      ((paymentMethod.value?.dinein_visitors
                        ?.only_network_visitors &&
                        currentUser.only_dinein) ||
                        paymentMethod.value?.dinein_users
                          ?.only_network_users) &&
                      !paymentMethod.value.deliveryMethodErrMsg &&
                      !paymentMethod.value.networkErrMessage &&
                      storeNetworkConnected
                    "
                  >
                    <ion-text color="complete" style="font-size: small">
                      {{
                        "cart.cart-components.payment-methods.you-are-connected-to-stores-network"
                          | translate
                      }}</ion-text
                    >
                  </div>
                </ion-label>
              </ion-col>

              <ion-col
                class="ion-no-padding ion-no-margin ion-text-left"
                [size]="6.5"
              >
                <span
                  *ngIf="
                    paymentMethod.key !== 'cash' &&
                    !paymentMethod.value.renderLikeCash &&
                    paymentMethod.key !== 'mobilePOS' &&
                    paymentMethod.key !== 'pre_cash' &&
                    paymentMethod.key !== 'pre_mobilePOS' &&
                    storesByStoreId &&
                    storesByStoreId[currentStoreId].paymentGateways &&
                    storesByStoreId[currentStoreId].paymentGateways[
                      paymentMethod.key
                    ] &&
                    storesByStoreId[currentStoreId].paymentGateways[
                      paymentMethod.key
                    ].cards
                  "
                >
                  <img
                    *ngIf="
                      storesByStoreId[currentStoreId].paymentGateways[
                        paymentMethod.key
                      ].cards.visa
                    "
                    alt="visa"
                    width="35px"
                    style="padding-right: 4px"
                    src="https://data.deliverymanager.gr/bankicons/visa.png"
                  />
                  <img
                    *ngIf="
                      storesByStoreId[currentStoreId].paymentGateways[
                        paymentMethod.key
                      ].cards.mastercard
                    "
                    alt="mastercard"
                    width="35px"
                    style="padding-right: 4px"
                    src="https://data.deliverymanager.gr/bankicons/mastercard.png"
                  />
                  <img
                    *ngIf="
                      storesByStoreId[currentStoreId].paymentGateways[
                        paymentMethod.key
                      ].cards.maestro
                    "
                    alt="maestro"
                    width="55px"
                    style="padding-right: 4px"
                    src="https://data.deliverymanager.gr/bankicons/maestro.png"
                  />
                  <img
                    *ngIf="
                      storesByStoreId[currentStoreId].paymentGateways[
                        paymentMethod.key
                      ].cards.discover
                    "
                    alt="discover"
                    width="55px"
                    style="padding-right: 4px"
                    src="https://data.deliverymanager.gr/bankicons/discover.png"
                  />
                  <img
                    *ngIf="
                      storesByStoreId[currentStoreId].paymentGateways[
                        paymentMethod.key
                      ].cards.diners
                    "
                    alt="diners"
                    width="40px"
                    style="padding-right: 4px"
                    src="https://data.deliverymanager.gr/bankicons/diners.jpg"
                  />
                  <img
                    *ngIf="
                      storesByStoreId[currentStoreId].paymentGateways[
                        paymentMethod.key
                      ].cards.american
                    "
                    alt="american"
                    width="88px"
                    style="padding-right: 4px"
                    src="https://data.deliverymanager.gr/bankicons/american.png"
                  />
                </span>

                <img
                  *ngIf="
                    storesByStoreId[currentStoreId]?.paymentGateways[
                      paymentMethod.key
                    ]?.cards?.googlePay
                  "
                  alt="google-pay"
                  width="42px"
                  style="padding-right: 4px"
                  src="https://data.deliverymanager.gr/bankicons/googlepay.png"
                />

                <img
                  *ngIf="
                    storesByStoreId[currentStoreId]?.paymentGateways[
                      paymentMethod.key
                    ]?.cards?.applePay
                  "
                  alt="apple-pay"
                  width="42px"
                  style="padding-right: 4px"
                  src="https://data.deliverymanager.gr/bankicons/applepay.png"
                />

                <img
                  *ngIf="
                    storesByStoreId[currentStoreId]?.paymentGateways[
                      paymentMethod.key
                    ]?.cards?.iris
                  "
                  alt="iris"
                  width="49px"
                  style="padding-right: 4px"
                  src="https://data.deliverymanager.gr/bankicons/iris.png"
                />

                <img
                  *ngIf="
                    storesByStoreId[currentStoreId]?.paymentGateways[
                      paymentMethod.key
                    ]?.cards?.googlePayTransparent
                  "
                  alt="google-pay"
                  [class]="darkMode ? 'invert' : ''"
                  width="42px"
                  style="padding-right: 4px"
                  src="https://data.deliverymanager.gr/bankicons/google-pay.png"
                />

                <img
                  *ngIf="
                    storesByStoreId[currentStoreId]?.paymentGateways[
                      paymentMethod.key
                    ]?.cards?.applePayTransparent
                  "
                  alt="apple-pay"
                  width="42px"
                  [class]="darkMode ? 'invert' : ''"
                  style="padding-right: 4px"
                  src="https://data.deliverymanager.gr/bankicons/apple-pay.png"
                />

                <img
                  *ngIf="
                    storesByStoreId[currentStoreId]?.paymentGateways[
                      paymentMethod.key
                    ]?.cards?.irisTransparent
                  "
                  alt="iris"
                  width="49px"
                  [class]="darkMode ? 'invert' : ''"
                  style="padding-right: 4px"
                  src="https://data.deliverymanager.gr/bankicons/irisTransparent.png"
                />
              </ion-col>
            </ion-row>

            <span
              style="position: absolute; bottom: 0; right: 3px"
              *ngIf="
                paymentMethod.key !== 'cash' &&
                !paymentMethod.value.renderLikeCash &&
                paymentMethod.key !== 'mobilePOS' &&
                paymentMethod.key !== 'pre_cash' &&
                paymentMethod.key !== 'pre_mobilePOS'
              "
            >
              <img
                *ngIf="paymentMethod.key === 'ethniki'"
                alt="ethniki"
                width="50px"
                src="https://data.deliverymanager.gr/bankicons/ethniki.png"
              />
              <img
                *ngIf="paymentMethod.key === 'nbg_ecommerce'"
                alt="nbg_ecommerce"
                width="50px"
                src="https://data.deliverymanager.gr/bankicons/ethniki.png"
              />
              <img
                *ngIf="paymentMethod.key === 'nbg_simplify'"
                alt="nbg_simplify"
                width="50px"
                src="https://data.deliverymanager.gr/bankicons/ethniki.png"
              />
              <img
                *ngIf="paymentMethod.key === 'mypos'"
                height="20px"
                alt="mypos"
                src="https://data.deliverymanager.gr/bankicons/mypos.png"
              />
              <img
                *ngIf="paymentMethod.key === 'viva'"
                width="50px"
                alt="viva"
                [class]="darkMode ? 'invert' : ''"
                src="https://data.deliverymanager.gr/bankicons/viva.png"
              />
              <img
                *ngIf="paymentMethod.key === 'piraeus'"
                width="20px"
                alt="piraeus"
                src="https://data.deliverymanager.gr/bankicons/piraeus.png"
              />
              <img
                *ngIf="paymentMethod.key === 'eurobank'"
                width="35px"
                alt="eurobank"
                src="https://data.deliverymanager.gr/bankicons/eurobank.png"
              />
              <img
                *ngIf="paymentMethod.key === 'nexi'"
                width="35px"
                alt="nexi"
                [class]="darkMode ? 'invert' : ''"
                src="https://data.deliverymanager.gr/bankicons/xpay-transparent.png"
              /><img
                *ngIf="paymentMethod.key === 'alpha'"
                width="45px"
                alt="alpha"
                src="https://data.deliverymanager.gr/bankicons/alpha.png"
              />
              <img
                *ngIf="paymentMethod.key === 'paypal'"
                width="35px"
                alt="paypal"
                src="https://data.deliverymanager.gr/bankicons/paypal.png"
              />
              <img
                *ngIf="paymentMethod.key === 'sumup'"
                width="45px"
                alt="sumup"
                [class]="darkMode ? 'invert' : ''"
                src="https://data.deliverymanager.gr/bankicons/sumup.png"
              />
            </span>
          </ion-item>
        </span>
      </ion-list>
    </ion-radio-group>
  </span>

  <app-invoice *ngIf="storeInfo"></app-invoice>
</ion-card>

<ion-grid *ngIf="storeInfo && groupApp && groupApp.active_reservation_app">
  <ion-list>
    <ion-item
      [button]="
        numberOfDisplaydPaymentMethods && numberOfDisplaydPaymentMethods > 1
          ? true
          : false
      "
      style="margin-left: 10px; margin-right: 10px; border-radius: 10px"
      lines="none"
      color="light"
      (click)="
        numberOfDisplaydPaymentMethods && numberOfDisplaydPaymentMethods > 1
          ? openReservationAppSelectPaymentMethodModal()
          : ''
      "
    >
      <ion-icon name="wallet"></ion-icon>
      <ion-label style="margin-left: 10px" *ngIf="selectedPaymentMethodID">
        {{
          displaySelectedPaymentMethodLabel ||
            (("reservation-app." + selectedPaymentMethodID) | translate)
        }}
      </ion-label>
      <ion-label style="margin-left: 10px" *ngIf="!selectedPaymentMethodID">{{
        "reservation-app.please-select" | translate
      }}</ion-label>
    </ion-item>
  </ion-list>
</ion-grid>
